import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import { Header as HeaderRNE } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';
import { useLanguage } from '../context/LanguageContext';
import LanguageSelect from './select/LanguageSelect';

interface Props {
    title: string;
    back: any;
    navigation: any;
}

const Header: React.FC<Props> = ({ title, back, navigation }) => {
    const { currentLanguage, changeLanguage } = useLanguage();

    return (
        <HeaderRNE
            leftComponent={
                <View>
                    {back !== null ? (
                        <TouchableOpacity onPress={navigation.goBack}>
                            <AntDesign name="back" size={24} color="black" />
                        </TouchableOpacity>
                    ) : undefined}
                </View>
            }
            rightComponent={
                <View
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <LanguageSelect
                        value={currentLanguage}
                        handleChangeLanguage={(lang: string) => {
                            void changeLanguage(lang);
                        }}
                        languageList={['en', 'ja']}
                    />
                </View>
            }
            centerComponent={{
                text: title,
                style: styles.heading,
            }}
            style={styles.headerContainer}
        />
    );
};

const styles = StyleSheet.create({
    headerContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#397af8',
        marginTop: 100,
        marginBottom: 20,
        width: '100%',
        paddingVertical: 15,
        borderBottomWidth: 1,
        borderBottomColor: '#cfcfcf',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginRight: 10,
        marginLeft: 10,
    },
    heading: {
        color: 'white',
        fontSize: 22,
        fontWeight: 'bold',
    },
    headerRight: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 5,
    },
    subheaderText: {
        color: 'white',
        fontSize: 16,
        fontWeight: 'bold',
    },
});

export default Header;
